module.exports = __webpack_public_path__ + "static/img/label-03.80f86e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/system/label-03.png
// module id = 5PtN
// module chunks = 31